import React, { useContext } from 'react'
import { useNavigate } from 'react-router-dom'
import Icon from '@embracesbs/component-icon'
import Text from '@embracesbs/component-text'
import LoadingState from '../Components/Common/LoadingState'
import SectionHeader from '../Components/Common/SectionHeader'
import { AuthRoleContext } from '../Components/Auth/AuthRoleContext'
import { developerToolsFor } from '../Components/MainMenu/navigation'

// Landing page for the developer tools: every tool the app offers, with a line
// on what each one is for. The list is the sidebar's own (navigation.ts),
// including its role gating, so the cards and the rail can never disagree.
const DeveloperCenter: React.FC = () => {
  const navigate = useNavigate()
  const roles = useContext(AuthRoleContext)

  // roles are fetched from /api/getroles and start as null, so wait for them
  // rather than hiding the admin tools from an administrator and telling them
  // why. The same wait is why DeleteTenant checks `roles === null`.
  if (roles === null) {
    return (
      <div style={{ height: 'var(--app-height, 100vh)' }}>
        <LoadingState text='Checking your permissions…' />
      </div>
    )
  }

  const tools = developerToolsFor(roles.isAdmin)

  return (
    <div
      style={{ height: 'var(--app-height, 100vh)', overflowY: 'auto', padding: '24px 40px', boxSizing: 'border-box' }}
      className='custom-scrollbar'
    >
      <div style={{ maxWidth: '980px' }}>
        <SectionHeader title='Developer center' />
        <Text
          textStyle='description'
          textColor='grey'
          content='Tools for working out what the platform is doing, and for operations that span many tenants.'
          style={{ display: 'block', margin: '4px 0 20px' }}
        />

        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', gap: '12px' }}>
          {tools.map((tool) => (
            <button key={tool.id} type='button' className='tma-tool-card' onClick={() => navigate(tool.path)}>
              <Icon iconName={tool.icon} size={20} color='var(--tma-accent)' style={{ flexShrink: 0, marginTop: '2px' }} />
              <span style={{ minWidth: 0 }}>
                <Text textStyle='body' content={tool.title} style={{ fontWeight: 600, display: 'block' }} />
                <Text textStyle='description' textColor='grey' content={tool.description} style={{ display: 'block', marginTop: '2px' }} />
              </span>
            </button>
          ))}
        </div>

        {!roles.isAdmin && (
          <Text
            textStyle='description'
            textColor='grey'
            content='Some tools (bulk update, stage rollout, config migration, certificates) are only shown to administrators.'
            style={{ display: 'block', marginTop: '16px' }}
          />
        )}
      </div>
    </div>
  )
}

export default DeveloperCenter
